import { Injectable } from '@angular/core';
import { Indicador } from '../comum/modelos/indicador';
import { IndicadorProcesso } from '../comum/modelos/indicador-processo';
import { IndicadorRotina } from '../comum/modelos/indicador-rotina';
import { IndicadorSetor } from '../comum/modelos/indicador-setor';
import { SettingsService } from '../settings.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class IndicadorService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/indicadores/';
  }

  obterIndicadoresClienteHttp(id: number): Observable<Indicador[]> {
    return this._http.get(this._host + 'cliente/' + id)
      .catch(this.handleError);
  }

  removerIndicadorHttp(idIndicador: number): Observable<HttpResponse<Indicador>> {
    return this._http
      .delete(this._host + idIndicador, {
        observe: 'response'
      }).catch(this.handleError);
  }

  cadastrarIndicadorHttp(indicador: Indicador): Observable<HttpResponse<Indicador>> {
    return this._http
      .post(this._host, indicador, {
        observe: 'response'
      }).catch(this.handleError);
  }

  atualizarIndicadorHttp(indicador: Indicador): Observable<HttpResponse<Indicador>> {
    return this._http
      .put(this._host, indicador, {
        observe: 'response'
      }).catch(this.handleError);
  }

  obterIndicadorPorIdHttp(id: number): Observable<Indicador> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  obterIndicadoresSetorHttp(id: number): Observable<IndicadorSetor[]> {
    return this._http.get(this._host + 'setor/' + id)
      .catch(this.handleError);
  }

  cadastrarIndicadoresSetorHttp(indicadoresSetor: IndicadorSetor[]): Observable<HttpResponse<IndicadorSetor[]>> {
    return this._http
      .post(this._host + 'setor/', indicadoresSetor, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerIndicadoresSetorHttp(indicadoresSetor: IndicadorSetor[]): Observable<HttpResponse<IndicadorSetor[]>> {
    return this._http
      .patch(this._host + 'setor/', indicadoresSetor, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterIndicadoresProcessoHttp(id: number): Observable<IndicadorProcesso[]> {
    return this._http.get(this._host + 'processo/' + id)
      .catch(this.handleError);
  }

  cadastrarIndicadoresProcessoHttp(indicadoresProcesso: IndicadorProcesso[]): Observable<HttpResponse<IndicadorProcesso[]>> {
    return this._http
      .post(this._host + 'processo/', indicadoresProcesso, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerIndicadoresProcessoHttp(indicadoresProcesso: IndicadorProcesso[]): Observable<HttpResponse<IndicadorProcesso[]>> {
    return this._http
      .patch(this._host + 'processo/', indicadoresProcesso, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterIndicadoresRotinaHttp(id: number): Observable<IndicadorRotina[]> {
    return this._http.get(this._host + 'rotina/' + id)
      .catch(this.handleError);
  }

  obterNotaMaximaIndicadorHttp(id: number): Observable<number> {
    return this._http.get(this._host + 'nota-maxima/' + id)
      .catch(this.handleError);
  }

  cadastrarIndicadoresRotinaHttp(indicadoresRotina: IndicadorRotina[]): Observable<HttpResponse<IndicadorRotina[]>> {
    return this._http
      .post(this._host + 'rotina/', indicadoresRotina, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerIndicadoresRotinaHttp(indicadoresRotina: IndicadorRotina[]): Observable<HttpResponse<IndicadorRotina[]>> {
    return this._http
      .patch(this._host + 'rotina/', indicadoresRotina, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/indicador/indicador.service.ts